/**
 * FT19-U31: Lease Contracts (FIN-FR-021).
 *
 * A per-module route file; the INT packet spreads `LEASE_ROUTES` into the router and adds the
 * nav item `leases` (`/finance/leases`, section s-2.1, code FIN-FR-021). The record, reports and
 * runs screens live under `/finance/leases/...`, so the one nav item covers them all by prefix.
 * `/reports` and `/runs` are declared before `/:id(\d+)`; the id pattern is numeric, so neither
 * could be read as an id anyway.
 */

import type { RouteRecordRaw } from 'vue-router'

import { LEASE_PERMISSIONS } from '@/modules/lease/permissions'

export const LEASE_PATHS = {
  list: '/finance/leases',
  contract: (id: number) => `/finance/leases/${id}`,
  reports: '/finance/leases/reports',
  runs: '/finance/leases/runs',
} as const

export const LEASE_ROUTES: RouteRecordRaw[] = [
  {
    path: '/finance/leases',
    name: 'leases',
    component: () => import('@/modules/lease/LeaseContractsListView.vue'),
    meta: { titleKey: 'lease.routeTitles.list', permission: LEASE_PERMISSIONS.read },
  },
  {
    path: '/finance/leases/reports',
    name: 'lease-reports',
    component: () => import('@/modules/lease/LeaseReportsView.vue'),
    meta: { titleKey: 'lease.routeTitles.reports', permission: LEASE_PERMISSIONS.read },
  },
  {
    path: '/finance/leases/runs',
    name: 'lease-runs',
    component: () => import('@/modules/lease/LeaseRunsView.vue'),
    meta: { titleKey: 'lease.routeTitles.runs', permission: LEASE_PERMISSIONS.read },
  },
  {
    path: '/finance/leases/:id(\\d+)',
    name: 'lease',
    component: () => import('@/modules/lease/LeaseContractView.vue'),
    meta: { titleKey: 'lease.routeTitles.contract', permission: LEASE_PERMISSIONS.read },
  },
]
